import { render, staticRenderFns } from "./tabKerjaProfil.vue?vue&type=template&id=68466c3e"
import script from "./tabKerjaProfil.vue?vue&type=script&lang=js"
export * from "./tabKerjaProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports